import * as React from "react";

function SvgBBiconsCiselniky(props) {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <g data-name="Obecn\xE9 ikony">
        <path
          d="M112 20.52l-60.89.05a8.14 8.14 0 00-8.26 8v142.89a8.14 8.14 0 008.26 8h98.08a7.77 7.77 0 007.87-7.67V64.7a3.94 3.94 0 00-3.93-3.94h-30.49a6.7 6.7 0 01-6.64-6.69V24.46a3.93 3.93 0 00-4-3.94zm11.46.12a3.93 3.93 0 00-3 3.84V49.4a19.64 19.64 0 000 2.26 4.85 4.85 0 001.8 3.5 5.05 5.05 0 003.27 1.08h27.5a3.93 3.93 0 003.79-5v-.07a5 5 0 00-.22-.77 7.06 7.06 0 00-1.72-2.7l-25.77-25.14a7.4 7.4 0 00-2.55-1.62 4.47 4.47 0 00-1-.27h-.3a4 4 0 00-1.78-.03zm-60.64 33H95a4.12 4.12 0 014.38 3.81v.24A4.13 4.13 0 0195 61.48H62.84a4.13 4.13 0 01-4.38-3.82v-.24a4.12 4.12 0 014.38-3.81zm-.42 23.54a4 4 0 11-4 4 3.94 3.94 0 014.02-4.03zm15.72.07H137a3.94 3.94 0 110 7.87H78.14a3.94 3.94 0 110-7.87zm-15.7 23.51a4 4 0 11-4 4 3.95 3.95 0 014-4zm15.72 0H137a3.94 3.94 0 110 7.87H78.14a3.94 3.94 0 110-7.87zm-15.72 23.69a4 4 0 11-4 4 3.95 3.95 0 014-4zm15.72 0H137a3.94 3.94 0 110 7.87H78.14a3.94 3.94 0 110-7.87zM62.42 148a4 4 0 11-4 4 3.95 3.95 0 014-4zm15.72 0H137a3.94 3.94 0 110 7.88H78.14a3.94 3.94 0 110-7.88z"
          fillRule="evenodd"
          data-name="Stredni hodnoty - ciselniky"
        />
      </g>
    </svg>
  );
}

export default SvgBBiconsCiselniky;
